import { render, staticRenderFns } from "./mussels.vue?vue&type=template&id=d11f9018&scoped=true&"
import script from "./mussels.vue?vue&type=script&lang=js&"
export * from "./mussels.vue?vue&type=script&lang=js&"
import style0 from "./mussels.vue?vue&type=style&index=0&id=d11f9018&lang=scss&scoped=true&"
import style1 from "./mussels.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d11f9018",
  null
  
)

/* custom blocks */
import block0 from "./mussels.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/app/components/page/header.vue').default,UiTransition: require('/app/components/ui/transition.vue').default})
